import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

const iso = (d: Date) => d.toISOString().slice(0, 10);

/**
 * Netto bij een brutobedrag. Loonheffing gaat per loonperiode, dus het netto van een dienst
 * of dag is bruto × (netto / bruto) van de periode waarin hij valt. Een benadering: het echte
 * netto staat op de loonstrook.
 */
export function useNetto() {
  const now = new Date();
  const from = iso(new Date(now.getFullYear() - 1, 0, 1));
  const to = iso(new Date(now.getFullYear() + 1, 2, 31));
  const { data } = useQuery({
    queryKey: ['netto-factoren', from, to],
    queryFn: () => api.netto.factoren(from, to),
    staleTime: 30 * 60_000,
  });
  return useCallback(
    (bruto: number | null | undefined, date: string): number | null => {
      if (bruto == null || !data) return null;
      const f = data.factoren.find((p) => date >= p.start_date && date <= p.end_date)?.factor
        ?? data.factoren.filter((p) => p.factor != null).at(-1)?.factor;
      return f != null ? Math.round(bruto * f * 100) / 100 : null;
    },
    [data]
  );
}
